import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ValidationsService {
  constructor() {}

  validarCPF(cpf: string): boolean {
    if (!cpf) return false; // Verifica se o CPF é nulo ou indefinido
    cpf = cpf.replace(/\D/g, '');

    if (cpf.length !== 11) {
      return false;
    }

    if (/^(\d)\1+$/.test(cpf)) {
      return false;
    }

    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = 11 - (soma % 11);
    let digitoVerificador1 = resto === 10 || resto === 11 ? 0 : resto;

    if (digitoVerificador1 !== parseInt(cpf.charAt(9))) {
      return false;
    }

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = 11 - (soma % 11);
    let digitoVerificador2 = resto === 10 || resto === 11 ? 0 : resto;

    if (digitoVerificador2 !== parseInt(cpf.charAt(10))) {
      return false;
    }

    return true;
  }

  validarSenha(event: any): boolean {
    const senha = event.target?.value;

    if (senha.length < 8) {
      return false;
    }

    if (senha.length > 30) {
      return false;
    }

    return true;
  }
  
  isValidPassword(password:any) {
    // Expressão regular para verificar se contém pelo menos um número
    const hasNumber = /[0-9]/;
    
    // Expressão regular para verificar se contém pelo menos um caractere especial
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/;
  
    // Verifica se a senha atende aos critérios
    return hasNumber.test(password) && hasSpecialChar.test(password);
  }
}
